import React from 'react';
import PropTypes from 'prop-types';

import {IconoirCheckCircle} from '@ey-xd/motif-icon';

import OutputText from '@ey/canvascoreservices/OutputText';
import Icon from '@ey/canvascoreservices/Icon';

import StyledDashboardCheck from './StyledDashboardCheck';

const DashboardCheck = ({condition, hide, placeholder}) => {
	return (
		<StyledDashboardCheck>
			{condition && <Icon src={IconoirCheckCircle} />}
			{!condition && !hide && (
				<OutputText body2 light>
					{placeholder}
				</OutputText>
			)}
		</StyledDashboardCheck>
	);
};

DashboardCheck.defaultProps = {
	hide: false,
	placeholder: '-'
};

DashboardCheck.propTypes = {
	condition: PropTypes.bool.isRequired,
	hide: PropTypes.bool,
	placeholder: PropTypes.string
};

export default DashboardCheck;
